import { useEffect, useState } from 'react';
import { Card } from 'antd';
import { useAuth } from '../../hooks/useAuth';
import { listActivities } from '../../api/activities';
import { round } from '../../utils/format';
import ActivityItem from './ActivityItem';
import './Activity.css';

export async function loader() {
  return {};
}

export async function action() {}

function Activity() {
  const [activities, setActivities] = useState({ data: [], summary: { distance: 0 } });
  const [status, setStatus] = useState('loading');
  const { user, isLoggedIn } = useAuth();

  useEffect(() => {
    let ignore = false;

    async function load() {
      if (!isLoggedIn) {
        setStatus('ready');
        return;
      }
      try {
        setStatus('loading');
        const result = await listActivities(user);
        if (!ignore) {
          setActivities(result);
          setStatus('ready');
        }
      } catch (err) {
        if (!ignore) setStatus('error');
      }
    }

    load();
    return () => {
      ignore = true;
    };
  }, [isLoggedIn, user]);

  if (!isLoggedIn) {
    return <div className="htv-state">Đăng nhập Strava để xem hoạt động của bạn.</div>;
  }

  if (status === 'loading') return <div className="htv-state">Đang tải hoạt động...</div>;
  if (status === 'error') return <div className="htv-state">Không tải được hoạt động.</div>;

  const totalDistance = activities?.summary?.distance || 0;

  return (
    <section className="activity-page">
      <header className="activity-header">
        <div>
          <p className="htv-muted">Hoạt động cá nhân</p>
          <h1>Nhật ký chạy bộ</h1>
        </div>
      </header>

      <div className="activity-summary-grid">
        <Card className="activity-summary">
          <p className="htv-muted">Tổng quãng đường</p>
          <strong>{round(totalDistance / 1000)} km</strong>
        </Card>
        <Card className="activity-summary">
          <p className="htv-muted">Số hoạt động</p>
          <strong>{activities?.data?.length || 0}</strong>
        </Card>
      </div>

      {activities?.data?.length ? (
        <div className="activity-grid">
          {activities.data.map((activity, index) => (
            <ActivityItem activity={activity} key={activity.id || index} />
          ))}
        </div>
      ) : (
        <div className="htv-state">Chưa có hoạt động nào được đồng bộ.</div>
      )}
    </section>
  );
}

export default Activity;
